import {SpyneTrait} from 'spyne';
import { PageDeckSlideView } from 'components/pages/page-deck-slide-view';
import SlideTmplTitle from "components/pages/templates/page-deck-templates/page-deck-title.tmpl.html";
import SlideTmplContent from "components/pages/templates/page-deck-templates/page-deck-content.tmpl.html";
import SlideTmplComparison from "components/pages/templates/page-deck-templates/page-deck-comparison.tmpl.html";


export class SlideTraits extends SpyneTrait {

  constructor(context){
    let traitPrefix = "slide$";

    super(context, traitPrefix);
  }

  static slide$AddSlides(slides=[]){

    const addSlide = (data)=>{
      const {type} = data;
      const template = SlideTraits.slide$GetTemplateByType(type);

      this.appendView(new PageDeckSlideView({data, template}))

    }

    slides.forEach(addSlide)

  }


  static slide$GetTemplateByType(type='content'){
    const templateLookup = {
      title: SlideTmplTitle,
      content: SlideTmplContent,
      comparison: SlideTmplComparison
    }

    return templateLookup[type] || "<div><h1>MISSING TEMPLATE TYPE</h1></div>";

  }

  static slide$HelloWorld(){
    return "Hello World";
  }

}

